<template>
  <div class="flex justify-center">
    <moon-loader :loading="true" color="#4f46e6" :size="this.size"></moon-loader>
  </div>
</template>

<script>
import MoonLoader from 'vue-spinner/src/MoonLoader.vue'

export default {
  props: {
    size: {
      default: "25px"
    }
  },
  components: {
    MoonLoader
  }
}
</script>
